export const IPS_ROOT_DOC = ['ukba_kasa', 'instagram_ips'];
export const IPS_ADMIN_PASSWORD = '1253';

export const IPS_DAYS = [
  { key: 'pazartesi', label: 'Pazartesi' },
  { key: 'sali', label: 'Salı' },
  { key: 'carsamba', label: 'Çarşamba' },
  { key: 'persembe', label: 'Perşembe' },
  { key: 'cuma', label: 'Cuma' },
  { key: 'cumartesi', label: 'Cumartesi' },
  { key: 'pazar', label: 'Pazar' }
];

export const DEFAULT_PLAN_ROWS = [
  'Instagram Reels',
  'Instagram Gönderi',
  'Instagram Hikaye 1',
  'Instagram Hikaye 2',
  'Instagram Hikaye 3',
  'Instagram Hikaye 4',
  'Instagram Hikaye 5',
  'Instagram Hikaye 6',
  'Instagram Hikaye 7',
  'WhatsApp Hikaye 1',
  'WhatsApp Hikaye 2',
  'WhatsApp Hikaye 3',
  'WhatsApp Kanalı'
];

export const CONTENT_TYPES = [
  'Reels',
  'Gönderi',
  'Hikaye',
  'WhatsApp Hikaye',
  'WhatsApp Kanalı'
];
